<template>
  <image-box-tool-with-options
    v-if="show"
    ref="menu"
    v-bind="{
      title,
      icon,
      shadow: false,
      ...$attrs
    }"
  >
    <template #default>
      <!-- <div class="p-2"> -->
      <color-picker-container
        @save="saveColor"
        @input="changeColor"
      />
      <!-- </div> -->
    </template>

    <template slot="icon">
      <div class="mr-2">
        <template v-if="fillColor === 'transparent'">
          <font-awesome-icon :icon="['far','minus-square']" />
        </template>
        <template v-if="fillColor === '#ffffff'">
          <font-awesome-icon :icon="['far','square']" />
        </template>
        <template v-else>
          <font-awesome-icon
            icon="square"
            :style="{color: fillColor}"
          />
        </template>
      </div>
    </template>
  </image-box-tool-with-options>
</template>
<script>
import ColorPickerContainer from '@/components/ColorPicker/ColorPickerContainer';
import ImageBoxTool from './ImageBoxTool';

export default {
  name: 'ColorBoxTool',
  components: {
    ColorPickerContainer,
  },
  extends: ImageBoxTool,
  inheritAttrs: false,
  props: {
    fillColor: {
      type: String,
      default: 'transparent',
    },
    submenuValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      title: 'Color',
      showLocal: true,
    };
  },
  computed: {
    show() {
      return this.showLocal;
    },
    showColors() {
      if (this.submenuValue === 'color') {
        return true;
      }
      return null;
    },
  },
  watch: {
    showColors(newval) {
      if (!newval) {
        this.$root.$emit('bv::hide::popover', 'popoverFill');
      }
    },
  },
  mounted() {
    this.activate();
    this.$nextTick().then(() => {
      this.canvas.on({
        'selection:created': this.activate,
        'selection:updated': this.activate,
      });
    });
  },
  methods: {
    activate() {
      if (this.canvas && this.canvas.getActiveObject()) {
        this.showLocal = (this.canvas.getActiveObject().get('type') === 'i-text' || this.canvas.getActiveObject().get('type') === 'textbox');
      } else {
        this.showLocal = false;
      }
    },
    changeColor(color) {
      this.canvas.renderAll();
      this.$emit('selectColor', color);
    },
    saveColor(color) {
      // Closing menu
      this.$refs.menu.close();
      // We need to render the canvas to apply these changes
      this.canvas.renderAll();
      this.$emit('selectColor', color);
      this.canvas.fire('object:modified', { target: this.canvas.getActiveObject() });
    },
  },
};
</script>
